/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PropertySearchRequestPrefecturesInnerChildrenInner from './PropertySearchRequestPrefecturesInnerChildrenInner';

/**
 * The PropertySearchRequestPrefecturesInner model module.
 * @module model/PropertySearchRequestPrefecturesInner
 * @version 1.0.0
 */
class PropertySearchRequestPrefecturesInner {
    /**
     * Constructs a new <code>PropertySearchRequestPrefecturesInner</code>.
     * @alias module:model/PropertySearchRequestPrefecturesInner
     */
    constructor() { 
        
        PropertySearchRequestPrefecturesInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PropertySearchRequestPrefecturesInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PropertySearchRequestPrefecturesInner} obj Optional instance to populate.
     * @return {module:model/PropertySearchRequestPrefecturesInner} The populated <code>PropertySearchRequestPrefecturesInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PropertySearchRequestPrefecturesInner();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [PropertySearchRequestPrefecturesInnerChildrenInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PropertySearchRequestPrefecturesInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PropertySearchRequestPrefecturesInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        if (data['children']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['children'])) {
                throw new Error("Expected the field `children` to be an array in the JSON data but got " + data['children']);
            }
            // validate the optional field `children` (array)
            for (const item of data['children']) {
                PropertySearchRequestPrefecturesInnerChildrenInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * 都道府県名
 * @member {String} name
 */
PropertySearchRequestPrefecturesInner.prototype['name'] = undefined;

/**
 * @member {Array.<module:model/PropertySearchRequestPrefecturesInnerChildrenInner>} children
 */
PropertySearchRequestPrefecturesInner.prototype['children'] = undefined;






export default PropertySearchRequestPrefecturesInner;

